export const chartsOption = {
  legend: {
    top: '20',
    icon: 'rect',
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  dataset: {
    dimensions: ['product', '该周期分数', '全周期平均分数'],
    source: [],
  },
  label: {
    show: true,
    position: 'right',
    formatter: (param) => {
      if (param.seriesData) {
        return `${param.seriesData[0].name}`
      } else {
        const rank = param.data[param.seriesName + 'rank']
        return `${param.data[param.seriesName]} ${rank ? '(' + rank + ')' : ''}`
      }
    },
  },
  xAxis: {
    type: 'value',
    position: 'top',
    boundaryGap: [0, 0.01],
  },
  yAxis: {
    type: 'category',
    splitArea: {
      show: true,
      interval: 0,
      areaStyle: {
        color: ['#f1f6fa', '#ffffff'],
      },
    },
  },
  series: [
    {
      type: 'bar',
      barWidth: 14,
      barGap: 0.6,
    },
    {
      type: 'bar',
      barWidth: 14,
      barGap: 0.6,
    },
  ],
}
